// extracted by mini-css-extract-plugin
export var askAiIcon = "_om-k";
export var category = "_om-a";
export var categoryHeader = "_om-f";
export var container = "_om-0";
export var group = "_om-b";
export var groupItems = "_om-g";
export var groupSeparator = "_om-l";
export var highlight = "_om-8";
export var loading = "_om-1";
export var noResults = "_om-3";
export var placeholder = "_om-2";
export var resultContent = "_om-5";
export var resultIcon = "_om-d";
export var resultItem = "_om-h";
export var resultMeta = "_om-9";
export var resultSubtitle = "_om-7";
export var resultSuffix = "_om-j";
export var resultTitle = "_om-6";
export var resultsList = "_om-4";
export var searchGroup = "_om-e";
export var selected = "_om-i";
export var subgroup = "_om-c";